export default __webpack_public_path__ + "static/park-pedregal-amenidades-04-salon-eventos-49a85b3f39b158538cdc641353086687.jpg";